<template>
  <c-modal class-name="profile-field-edit-dictionary-modal" :active="displayModal" :title="title" @close="close">
    <div class="form-group">
      <c-input v-model="query" class="search" placeholder="Поиск по значению" :clearable="true" icon="search" />
    </div>

    <div class="form-group">
      <div v-if="!filteredList.length">
        <div v-if="normalizedQuery.length" class="empty-message">Ничего не найдено</div>
        <div v-else class="empty-message">В справочнике пока нет значений</div>
      </div>

      <shadow-scroll-container
        class="variants-list"
        :class="{
          'need-space': filteredList.length === 1,
        }"
      >
        <div ref="list">
          <transition-group name="slide" @after-enter="afterEnter">
            <div
              v-for="variant in filteredList"
              :key="variant.unique"
              :data-variant="variant.unique"
              class="variant-wrapper"
            >
              <variant-form
                v-if="variant.unique === editedVariant"
                :variant="variant"
                :list="list"
                @close="editedVariant = null"
              />

              <div v-else class="variant">
                <div class="variant__text">{{ variant.text }}</div>
                <div class="variant__actions">
                  <c-button
                    v-b-popover.html="{
                      container: '#app',
                      trigger: 'hover blur',
                      content: 'Редактировать',
                      placement: 'top',
                    }"
                    class="variant__edit"
                    icon="edit"
                    size="iconic"
                    @click="editedVariant = variant.unique"
                  />
                  <c-button
                    v-b-popover.hover.blur.top="'Удалить'"
                    class="variant__remove"
                    size="iconic"
                    :icon="{ icon: 'trash', color: 'secondary' }"
                    @click="removeVariant(variant)"
                  />
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </shadow-scroll-container>
    </div>

    <c-button size="small" :icon="{ icon: 'plus', color: 'primary' }" label="Добавить значение" @click="addVariant" />

    <template #actions>
      <c-button size="large" label="Отменить" @click="close" />
      <c-button label="Сохранить" color="primary" size="large" @click="submit" />
    </template>
  </c-modal>
</template>

<script>
import CButton from "@/components/controls2/Button";
import CInput from "@/components/controls2/Input";
import CModal from "@/components/scrollable-modal";
import ShadowScrollContainer from "@/components/shadow-scroll-container";
import VariantForm from "./VariantForm";

export default {
  components: {
    CButton,
    CInput,
    CModal,
    ShadowScrollContainer,
    VariantForm,
  },
  props: ["fieldName", "list"],
  data() {
    return {
      displayModal: false,
      isSubmitted: false,
      editedVariant: null,
      query: "",
      scrollTo: null,
    };
  },

  computed: {
    title() {
      return `Редактировать справочник поля <span class="font-weight-normal">${this.fieldName || ""}</span>`;
    },
    normalizedQuery() {
      return this.query.trim().toLowerCase();
    },
    filteredList() {
      return this.list.filter((variant) => variant.text.toLowerCase().includes(this.normalizedQuery));
    },
  },

  methods: {
    open(scrollTo) {
      this.scrollTo = scrollTo;
      this.displayModal = true;
    },

    close() {
      this.displayModal = false;
      this.reset();
      this.$emit("close");
    },

    reset() {
      this.isSubmitted = false;
      this.editedVariant = null;
    },

    addVariant() {
      this.$emit("addVariant");
    },

    removeVariant(variant) {
      this.$emit("removeVariant", variant);
    },

    submit() {
      this.$emit("updated");
      this.close();
    },

    afterEnter() {
      if (this.scrollTo) {
        const { list } = this.$refs;
        if (list) {
          this.$nextTick(() => {
            const variant = this.$refs.list.querySelector(`[data-variant="${this.scrollTo}"]`);
            if (variant) {
              variant.scrollIntoView({ behavior: "smooth" });
              this.scrollTo = null;
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
.search {
  /deep/ {
    input::placeholder {
      font-style: italic;
      font-weight: normal;
    }
  }
}
.variants-list {
  max-height: 425px;

  &.need-space {
    /deep/ {
      .scroll-container {
        overflow: visible;
      }
    }
  }

  @include beforeBootstrapMd {
    max-height: none;
  }
}
.variant-wrapper {
  border-bottom: 1px solid #dfe4ef;
  padding: 14px 10px;

  &:first-child {
    border-top: 1px solid #dfe4ef;
  }
}
.variant {
  display: flex;
  &__text {
    flex-grow: 1;
    font-size: 13px;
    word-break: break-word;
    padding-right: 12px;
  }
  &__actions {
    display: flex;
    flex-shrink: 0;
  }
  &__edit {
    margin-right: 12px;
  }
  &__remove {
    transform: translateY(-2px);
  }
}
.empty-message {
  font-size: 15px;
  color: #8e9cbb;
}
</style>

<style>
.profile-field-edit-dictionary-modal {
  max-width: 590px !important;
}
</style>
